import createSharedCachedFactory from "../memo/createSharedCachedFactory"

export const useMouseDragList = createSharedCachedFactory((): Array<MouseEvent> => {
  return []
})
